__turbopack_context__.v({
  "add_location_btn": "styles-module-scss-module__jCYcxq__add_location_btn",
  "new_search_button": "styles-module-scss-module__jCYcxq__new_search_button",
  "partial_search_text": "styles-module-scss-module__jCYcxq__partial_search_text",
  "results_filters_container": "styles-module-scss-module__jCYcxq__results_filters_container",
  "results_headings_container": "styles-module-scss-module__jCYcxq__results_headings_container",
  "results_location_container": "styles-module-scss-module__jCYcxq__results_location_container",
  "save_search_button": "styles-module-scss-module__jCYcxq__save_search_button",
  "tag": "styles-module-scss-module__jCYcxq__tag",
  "tag_container": "styles-module-scss-module__jCYcxq__tag_container",
});
